// filters
export const SEASON_ID = "?season_id=";
export const STATUS = "?status=";
export const ROUND_ID = "?round_id=";

// values
export const LIVE = "live";
